module.exports = __webpack_public_path__ + "img/upload-err1.5351aad5.png";